// TODO importar un api de ser necesario y en el API, una entidad de tipo modelo e implementarla aquí

export interface BaseCatalogo {
  id: any;
  nombre: string;
}

export class Catalog implements BaseCatalogo {
  constructor(public id: any, public nombre: string) {}
}
